import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all teachers (search gurus) */
export const getAllSearchGurus = async (searchQuery = "", status = "", params = {}) => {
    try {
        // Build query parameters
        const queryParams = new URLSearchParams();

        // Add search query if provided
        if (searchQuery) {
            queryParams.append("search", searchQuery);
        }

        // Add status filter if provided
        if (status) {
            queryParams.append("status", status);
        }

        // Add pagination params (page, limit, etc.)
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
                // Skip limit if it's 10 (backend default)
                if (key === 'limit' && params[key] === 10) {
                    return;
                }
                queryParams.append(key, params[key]);
            }
        });

        // Construct the final URL
        const url = `${apiUrlOne}/teachers/all${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;

        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching teachers:", error);
        throw error;
    }
};

/* Create a new teacher */
export const createSearchGuru = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/teachers/create-teacher-admin`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating teacher:", error);
        throw error;
    }
};

/* Update an existing teacher */
export const updateSearchGuru = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/teachers/${id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating teacher:", error);
        throw error;
    }
};

/* Delete a teacher */
export const deleteSearchGuru = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/teachers/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting teacher:", error);
        throw error;
    }
};
